module.exports = __webpack_public_path__ + "static/formPhotos-90171e95d8a29a8451d0d61a93fba45a.jpg";